import { configureStore } from '@reduxjs/toolkit'
import themeReducer from './theme'
import userInfoReducer from 'src/store/userinfo'
import loginReducer from 'src/store/login'
import aclsManagerReducer from 'src/store/acls_manager'
import rolesManagerReducer from 'src/store/roles_manager'
import usersReducer from 'src/store/users'
import brandsReducer from 'src/store/brand'
import categoriesReducer from 'src/store/category'
import documentsReducer from 'src/store/document'
import appointmentsReducer from 'src/store/appointments'
import contractsReducer from 'src/store/contracts'
import calendarReducer from 'src/store/calendar'
import metadataReducer from 'src/store/metadata'
import messagesReducer from 'src/store/messages'
import dealersReducer from 'src/store/dealers'

const addGlobalResetEnhancer = createStore => (reducer, initialState, enhancer) => {
  const resettableReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
      console.log('RESET STORE')
      return reducer(undefined, action)
    } else {
      return reducer(state, action)
    }
  }
  return createStore(resettableReducer, initialState, enhancer)
}

export function makeStore() {
  return configureStore({
    reducer: {
      theme: themeReducer,
      userInfo: userInfoReducer,
      loginData: loginReducer,
      aclsManager: aclsManagerReducer,
      rolesManager: rolesManagerReducer,
      users: usersReducer,
      brands: brandsReducer,
      categories: categoriesReducer,
      appointments: appointmentsReducer,
      metadata: metadataReducer,
      contracts: contractsReducer,
      documents: documentsReducer,
      calendar: calendarReducer,
      messages: messagesReducer,
      dealers: dealersReducer,
    },

    devTools: process.env.NODE_ENV !== 'production',
    enhancers: [addGlobalResetEnhancer],
  })
}

const store = makeStore()
export default store

export const resetStore = () => store.dispatch({ type: 'RESET_STORE' })
